import { render, staticRenderFns } from "./PracticeAreaPage.vue?vue&type=template&id=c5ec69d0"
import script from "./PracticeAreaPage.vue?vue&type=script&lang=js"
export * from "./PracticeAreaPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeAreaPage.vue?vue&type=style&index=0&id=c5ec69d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports